module.exports = __webpack_public_path__ + "img/hero-counseling.05e271c9.svg";